<script lang="ts">
    import { _ } from 'svelte-i18n';

    import Spinner from '../Spinner/Spinner.svelte';

    export let isOpen: boolean = false;
    export let message: string = '';

</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            {#if message}
                <div style="text-align: center;">{$_(message)}</div>
            {/if}
            <Spinner/>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 390px;
        max-width: 95vw;
        max-height: 95vh;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        /*border: 3px solid var(--automapa-blue);*/
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }
</style>
